export default {
  lines: [
    {
      fromName: '阿巴嘎旗',
      toName: '勐海县',
      coords: [
        [
          114.971,
          44.0227,
        ],
        [
          100.448,
          21.9559,
        ],
      ],
      count: 1,
    },
    {
      fromName: '阿巴嘎旗',
      toName: '矿区',
      coords: [
        [
          114.971,
          44.0227,
        ],
        [
          113.559,
          37.8701,
        ],
      ],
      count: 11,
    },
    {
      fromName: '阿巴嘎旗',
      toName: '濮阳县',
      coords: [
        [
          114.971,
          44.0227,
        ],
        [
          115.024,
          35.7104,
        ],
      ],
      count: 3,
    },
    {
      fromName: '阿巴嘎旗',
      toName: '山海关区',
      coords: [
        [
          114.971,
          44.0227,
        ],
        [
          119.754,
          39.998,
        ],
      ],
      count: 1,
    },
    {
      fromName: '阿巴嘎旗',
      toName: '叶城县',
      coords: [
        [
          114.971,
          44.0227,
        ],
        [
          77.4203,
          37.8847,
        ],
      ],
      count: 124,
    },
  ],
  garden: [
    {
      name: '阿巴嘎旗',
      value: [114.971, 44.0227],
      datas: 1354,
      type: 1,
    },
  ],
  grass: [
    {
      name: '勐海县',
      value: [100.448, 21.9559],
      datas: 2468,
    },
  ],
  cow: [
    {
      name: '矿区',
      value: [113.559, 37.8701],
      datas: 2468,
    },
  ],
  horse: [
    {
      name: '濮阳县 ',
      value: [115.024, 35.7104],
      datas: 2468,
    },
  ],
  sheep: [
    {
      name: '山海关区',
      value: [119.754, 39.998],
      datas: 2468,
    },
    {
      name: '叶城县',
      value: [77.4203, 37.8847],
      datas: 2468,
    },
  ],
};
